import api from '@/api/api'
import router from '@/router/index'
import _id from './_id/store'
import { normalize, schema } from 'normalizr'

export const reserva = new schema.Entity('reserva')

export default {
  namespaced: true,
  modules: {
    _id
  },
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    },
    updateSet (state, payload) {
      state.list = Object.assign({}, state.list, payload)
    }
  },
  actions: {
    loadAll ({ dispatch }, parametros) { // Devuelve todas las facturas
      return new Promise((resolve, reject) => {
        api.get('/reservas/get_lista', {
          params: {
            jsondata: JSON.stringify({
              parametros
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarReservas ({ dispatch }) { // Devuelve la cantidad de reservas que hay de ambos tipos
      return new Promise((resolve, reject) => {
        api.get('/reservas/comprobar_reservas')
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificar ({ dispatch }, {id, fechaLimite}) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/modificar', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              fechaLimite
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    eliminar ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/eliminar', {
          jsondata: JSON.stringify({
            parametros: {
              id: id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobar_eliminar_bo ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/comprobar_eliminar_bo', {
          jsondata: JSON.stringify({
            parametros: {
              id: id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    aceptarCondiciones ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/aceptar_condiciones', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, reserva)
              commit('updateSet', normalizedData.entities)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    // pagarStripe ({ commit, dispatch }, {id, stripeToken}) {
    //   return new Promise((resolve, reject) => {
    //     api.post('/reservas/pagar_stripe', {
    //       jsondata: JSON.stringify({
    //         parametros: {
    //           id,
    //           stripeToken
    //         }
    //       })
    //     })
    //       .then(response => {
    //         if (response.data.result.ok) {
    //           let normalizedData = normalize(response.data.result.data.data.reserva, reserva)
    //           commit('updateSet', normalizedData.entities)
    //           resolve()
    //         } else {
    //           switch (response.data.result.code) {
    //             case 1:
    //               dispatch('alerts/addNotLoggedIn', null, { root: true })
    //               router.push({ name: 'login' })
    //               break
    //           }
    //           reject(response.data.result)
    //         }
    //       })
    //       .catch(e => {
    //         reject(e)
    //       })
    //   })
    // },
    enviarCorreoAviso ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/enviar_correo_aviso', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    enviarCorreoTerminado ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/enviar_correo_terminado', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedDataReserva = normalize(response.data.result.data.data.reserva, reserva)
              commit('reservas/updateSet', normalizedDataReserva.entities, { root: true })
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    enviarCorreoStepper ({ dispatch }, {id, step}) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/enviar_correo_stepper', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              step
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    sincronizarReserva ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/resincronizar_reserva', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              if (response.data.result.data.data.sincronizacion.ok) {
                dispatch('_id/cargarDatosNormalizados', response.data.result.data.data.reserva)
                  .then(() => {
                    resolve()
                  })
              } else {
                reject(response.data.result.data.data.sincronizacion)
              }
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    },
    getCards (state) {
      return state.cards
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservas/store.js